// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"73ca492c","772":"c81e710a","850":"376f7054"}[chunkId] + ".chunk.js";
};